// Resolves the chosen digital-twin name (e.g. "Nitram") from the persona, with a
// safe fallback. Cached for a minute so it's cheap to call from every screen.

import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';

interface PersonaResp { persona: { digitalTwinName: string } }

/** The configured twin name (e.g. "Nitram") or "the twin" if not yet set. */
export function useTwinName(): string {
  const { data } = useQuery<PersonaResp>({
    queryKey: ['persona', 'twinName'],
    queryFn: () => api<PersonaResp>('/api/persona'),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
  return (data?.persona.digitalTwinName ?? '').trim() || 'the twin';
}
